<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button defaultHref="/call/dashboard" text="" icon="chevron-back"></ion-back-button>
    </ion-buttons>
    <ion-title>Scheduled Trip Requests</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-refresher slot="fixed" (ionRefresh)="loadData($event, false)">
    <ion-refresher-content pullingIcon="caret-down" pullingText="Pull to refresh" refreshingSpinner="circles"
      refreshingText="Refreshing...">
    </ion-refresher-content>
  </ion-refresher>

  <ion-list class="list-history">
    <ion-card class="ion-margin-top card-history" *ngFor="let item of listHistory">
      <ion-card-header>
        <div class="header">
          <ion-label class="alert-label" *ngIf="claim === userType.Driver">
            <ion-icon name="alarm-outline"></ion-icon>
            Booking alert: Time-sensitive! Act quickly, as this booking is visible to other drivers as well.
          </ion-label>
          <h2 class="title" *ngIf="claim === userType.Caller">
            <div class="ico">
              <ion-img src="assets/images/map/car_normal.png" />
            </div>
            <p>
              {{ item.nomePassageiro }}
              <small>
                <ion-icon name="call"></ion-icon> {{ item.celular }}
              </small>
            </p>
          </h2>
        </div>
      </ion-card-header>

      <div class="card-body">
        <div class="data">
          <ion-item *ngIf="item?.dataAgendamentoCorrida">
            <ion-icon name="alarm"></ion-icon>
            <ion-label>{{ item?.dataAgendamentoCorrida | date: "MM/dd/yyyy h:mm a"}}</ion-label>
          </ion-item>
          <ion-item>
            <ion-icon name="pin" slot="start"></ion-icon>
            <ion-icon *ngIf="item?.vendedor.porcentagem" name="flash" slot="start"></ion-icon>
            <ion-label>{{ item?.enderecoOrigem }}</ion-label>
          </ion-item>
          <ion-item>
            <ion-icon name="navigate" slot="start"></ion-icon>
            <ion-label>{{ item?.enderecoDestino }}</ion-label>
          </ion-item>
          <ion-item *ngIf="item?.saldo">
            <ion-icon name="cash" slot="start"></ion-icon>
            <ion-label>Trip price: {{ item?.saldo.valorCorrida | currency }}</ion-label>
          </ion-item>
          <ion-item *ngIf="item?.saldo && claim === userType.Driver">
            <ion-icon name="card" slot="start"></ion-icon>
            <ion-label>Trip fee: {{ item?.saldo.valorMotorista | currency }}</ion-label>
          </ion-item>
          <ion-item *ngIf="item?.motivoCancelamento">
            <ion-icon name="chatbubbles" slot="start"></ion-icon>
            <ion-label>{{ item?.motivoCancelamento }}</ion-label>
          </ion-item>
        </div>

        <div class="flags">
          <ion-img *ngIf="item?.idiomas.includes(Languages.English)" src="assets/English.svg" class="ico" alt="" />
          <ion-img *ngIf="item?.idiomas.includes(Languages.Portuguese)" src="assets/Portuguese.svg" class="ico" alt="" />
          <ion-img *ngIf="item?.idiomas.includes(Languages.Spanish)" src="assets/Spanish.png" class="ico" alt="" />
          <ion-img *ngIf="item?.idiomas.includes(Languages.Mandarin)" src="assets/Mandarin.png" class="ico" alt="" />
          <ion-img *ngIf="item?.idiomas.includes(Languages.French)" src="assets/French.png" class="ico" alt="" />
          <ion-img *ngIf="item?.idiomas.includes(Languages.Italian)" src="assets/Italian.png" class="ico" alt="" />
          <ion-img *ngIf="item?.idiomas.includes(Languages.Japanese)" src="assets/Japanese.png" class="ico" alt="" />
          <ion-img *ngIf="item?.idiomas.includes(Languages.Arabic)" src="assets/Arabic.png" class="ico" alt="" />
          <ion-img *ngIf="item?.idiomas.includes(Languages.German)" src="assets/German.png" class="ico" alt="" />
          <ion-img *ngIf="item?.idiomas.includes(Languages.Russian)" src="assets/Russian.png" class="ico" alt="" />
          <ion-img *ngIf="item?.idiomas.includes(Languages.Vietnamese)" src="assets/Vietnamese.png" class="ico" alt="" />
        </div>
      </div>

      <div class="footer">
        <span class="status-badge" [ngClass]="'status-' + getCardColor(item)">
          <ion-icon name="flag"></ion-icon>
          {{ status[item?.statusCorrida] == 'DISPUTED' ? 'IN DISPUTE' : (status[item?.statusCorrida] | titlecase) }}
        </span>
        <div class="footer-actions">
          <button *ngIf="claim === userType.Driver" class="btn-pill btn-go" (click)="acceptTrip(item)">
            Accept Trip
          </button>
          <button *ngIf="claim === userType.Caller" class="btn-pill btn-secondary" (click)="shareTrip(item)">
            <ion-icon name="share-social-outline"></ion-icon> Share
          </button>
          <button *ngIf="claim === userType.Caller" class="btn-pill btn-danger" (click)="cancelRace(item)">
            Cancel Trip
          </button>
        </div>
      </div>
    </ion-card>
  </ion-list>

  <ion-list class="ion-padding ion-text-center" *ngIf="!listHistory.length" class="list-history">
    <ion-card class="ion-margin-top card-history"> No results found. </ion-card>
  </ion-list>

  <div *ngIf="isOpenCanceling" class="container-comment" [ngClass]="{ open: isOpenCanceling }">
    <form [formGroup]="formCancelation">
      <h3>
        <ion-icon name="chatbox"></ion-icon>
        Please place the reason for the cancellation.
      </h3>
      <div class="container">
        <input formControlName="motivoCancelamento" type="text" class="input" placeholder="Enter reason" />
        <ion-button shape="round" size="small" (click)="postReason()" [disabled]="formCancelation.invalid">Send
        </ion-button>
      </div>
    </form>
  </div>

  <app-modal-component *ngIf="showModalFilter" (stateOpen)="showModalFilter = $event">
    <form [formGroup]="filterForm">
      <ion-item *ngIf="claim === userType.Caller">
        <ion-label position="floating">Client name</ion-label>
        <ion-input type="text" formControlName="nomeCliente"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating">Begin date</ion-label>
        <ion-input type="datetime-local" formControlName="dataInicio"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating">End date</ion-label>
        <ion-input type="datetime-local" formControlName="dataFim"></ion-input>
      </ion-item>
    </form>
    <button class="ion-margin-top button-bigger grey" (click)="filterData(null, true)">Search</button>
  </app-modal-component>

  <ion-fab vertical="bottom" horizontal="end" slot="fixed" size="small">
    <ion-fab-button *ngIf="!isFiltered" color="primary" (click)="showFilter()">
      <ion-icon name="search"></ion-icon>
    </ion-fab-button>
    <ion-fab-button *ngIf="isFiltered" color="primary" (click)="loadData(null, false)">
      <ion-icon name="close"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-content>
